export default __webpack_public_path__ + "static/media/watches world.9fd542a0.png";